export const LOG_GROUP_PREFIX_MAX = 5;
export const LOG_GROUP_PREFIX_MIN_LENGTH = 3;
export const LOG_GROUP_ACCOUNT_MAX = 20;
